import { z } from "zod";

import { NO_DISPLAY, YES_DISPLAY } from "@/intake-forms/constants/yes-no-display";
import { zSignatureInitialsRequired } from "@/utils/zod";

const numericOrEmptyField = z.union([z.string(), z.number()]).optional();
const yesNoDisplayField = z.enum([YES_DISPLAY, NO_DISPLAY]).nullable().optional();

export const cervicalExamFlowsheetFormSchema = z.object({
  examDate: z.date().nullable(),
  examTime: z.string().nullable(),
  dilation: numericOrEmptyField,
  effacement: numericOrEmptyField,
  station: numericOrEmptyField,
  consistency: z.string().nullable().optional(),
  locationOfCervix: z.string().nullable().optional(),
  fetalPresentation: z.string().nullable().optional(),
  activeLabor: yesNoDisplayField,
  notes: z.string().optional(),
  signatureInitials: zSignatureInitialsRequired(),
});

export type CervicalExamFlowsheetFormSchemaType = z.infer<typeof cervicalExamFlowsheetFormSchema>;
